import { render, staticRenderFns } from "./ChannelCategoryListAssociationView.vue?vue&type=template&id=1f4e0a9e&"
import script from "./ChannelCategoryListAssociationView.vue?vue&type=script&lang=js&"
export * from "./ChannelCategoryListAssociationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports